'use client'

import { useSearchParams } from 'next/navigation'
import { Suspense } from 'react'

type QueryParamsWrapperProps = {
  children: (params: URLSearchParams) => React.ReactNode
}

function QueryParamsContent({ children }: QueryParamsWrapperProps) {
  const searchParams = useSearchParams()
  const params: { [key: string]: string } = {}

  searchParams.forEach((value, key) => {
    params[key] = value
  })

  return children(new URLSearchParams(params))
}

export function QueryParamsWrapper({ children }: QueryParamsWrapperProps) {
  return (
    <Suspense fallback={null}>
      <QueryParamsContent>{children}</QueryParamsContent>
    </Suspense>
  )
}
